import { Col, Container, Row } from '@paypalcorp/pp-react'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import HamburgerIcon from '../HamburgerSVG'
import LoginButton from '../LoginButton/LoginButton'
import NavigationButtons from '../NavigationButtons/NavigationButtons'
import PaypalDeveloperSVG from '../PayPalDeveloperSVG'
import './navbar.css'

interface NavbarProps {
  user: any // TODO: define a new interface with all the values expected from the user and add use interface like UserProps
  location: Location
  inverseHeaderScheme: boolean
}

export const Navbar: React.FC<NavbarProps> = ({
  user,
  location,
  inverseHeaderScheme,
}) => {
  const [launcher, setLauncher] = useState<any>(null)
  const [loginURL, setLoginURL] = useState('')
  const [logoutURL, setLogoutURL] = useState('')
  const userLoggedOut = !isEmpty(user) && !user.loggedIn

  const alternateColorFun = (() => {
    if (inverseHeaderScheme) return 'header-web-home'
    return 'header-web-not-home'
  })()

  useEffect(() => {
    if (!isEmpty(user)) {
      setLoginURL(
        user.login.url.replace(
          /PAGEURL/g,
          encodeURIComponent((location && location.href) || '#'),
        ),
      )
      setLogoutURL(
        user.logout.url.replace(
          /PAGEURL/g,
          encodeURIComponent((location && location.href) || '#'),
        ),
      )
    }
  }, [location, user])

  useEffect(() => {
    setLauncher(
      typeof window !== `undefined`
        ? require('@paypalcorp/dx-ui-react/')
        : null,
    )
  }, [])

  return (
    <Container
      fluid={true}
      className={
        !userLoggedOut
          ? `header-web ${alternateColorFun} header-web-loggedIn`
          : `header-web ${alternateColorFun}`
      }
    >
      <Row>
        <Col xs={3} lg={4} className="nav-col">
          <div className="firstCol-wrapper">
            <HamburgerIcon />
            <a href="/">
              <PaypalDeveloperSVG />
            </a>
            <span className={`algoliaSearchlaunch Web ${'search-input'}`}>
              {launcher && <launcher.SearchModal />}
            </span>
          </div>
        </Col>
        <Col xs={2} lg={1} className="spacer-col" />
        <Col xs={6} lg={5} className="nav-col">
          {/* TODO: this props does not exist on this component - user={user} loginURL={loginURL}  */}
          <NavigationButtons />
        </Col>
        <Col xs={1} lg={2} className="nav-col">
          {userLoggedOut ? (
            <LoginButton user={user} loginURL={loginURL} />
          ) : null}
        </Col>
      </Row>
    </Container>
  )
}
